"use client";

import React from "react";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { Star, ShieldCheck, Award } from "lucide-react";
export default function ClientIntelligence() {
  return <section data-section-id="22182" id="client-intelligence" className="bg-background text-foreground relative overflow-hidden py-16 md:py-24">
      <div className="bg-border/10 pointer-events-none absolute top-0 bottom-0 left-1/4 hidden w-[1px] md:block" />
      <div className="bg-border/10 pointer-events-none absolute top-0 bottom-0 right-1/4 hidden w-[1px] md:block" />

      <div className="container relative z-10 mx-auto max-w-[1440px] px-6 md:px-10">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="mb-16 md:mb-24">
          <div className="mb-6 flex items-center gap-4">
            <div className="bg-primary h-1.5 w-1.5 rotate-45" />
            <span className="text-primary font-mono text-xs tracking-[0.25em] uppercase">
              Field Reports
            </span>
          </div>
          <h2 className="font-default text-4xl font-light tracking-tight md:text-5xl lg:text-6xl">
            Client <span className="font-thin italic">Intelligence</span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.1
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }}>
          <Card className="bg-card border-border group relative flex flex-col items-center justify-between gap-8 border p-8 md:p-12 transition-colors duration-500 hover:border-primary lg:flex-row">
            <CardContent className="flex flex-col items-start gap-4 p-0">
              <div className="flex items-center gap-3">
                <div className="bg-primary/10 flex h-10 w-10 items-center justify-center rounded-lg border border-primary/20 text-primary">
                  <ShieldCheck className="h-5 w-5" />
                </div>
                <div>
                  <h3 className="font-default text-card-foreground text-xl font-medium tracking-tight">
                    Verified Credentials & Trust
                  </h3>
                  <p className="text-muted-foreground font-mono text-xs tracking-wider uppercase">
                    [REF: TRUST-01] Official Standards
                  </p>
                </div>
              </div>
              <p className="text-card-foreground/80 max-w-2xl font-default text-lg font-light leading-relaxed">
                Certified SDVOSB (Service-Disabled Veteran-Owned Small Business) delivering elite precision, rigorous water chemistry engineering, and uncompromising aquatic performance.
              </p>
            </CardContent>

            <div className="flex flex-col items-start gap-4 lg:items-end">
              <Link to="https://google.com" newTab className="inline-flex">
                <Badge variant="outline" className="bg-accent text-primary border-primary font-mono text-xs tracking-widest uppercase px-4 py-2 hover:bg-primary hover:text-primary-foreground transition-colors">
                  <Star className="mr-1.5 h-3.5 w-3.5 fill-current" />
                  4.8 out of 5 stars from 17 Google reviews
                </Badge>
              </Link>
              <div className="text-muted-foreground flex items-center gap-2 font-mono text-[11px] tracking-widest uppercase">
                <Award className="h-4 w-4 text-primary" />
                Federal & Commercial Verified
              </div>
            </div>
          </Card>
        </motion.div>
      </div>
    </section>;
}